<template>
	<div class="wages wrapper shadow">
		<div class="operation">
			<div class="left">
				<div class="main-title">个人信息管理</div>
				<el-button type="primary" class="main-btn main-btn-primary" @click="addData">添加</el-button>
				<el-button type="primary" class="main-btn main-btn-primary" @click="importPerson">导入</el-button>
				<el-button type="primary" class="main-btn main-btn-primary" @click="importBank">导入银行信息</el-button>
				<el-button type="primary" class="main-btn main-btn-primary" @click="exportData">导出</el-button>
<!--				<el-button :type="selectStatus" class="main-btn"-->
<!--					:class="{ 'main-btn-warning': selectStatus == 'warning' }" @click="batchQuit">批量离职</el-button>-->
				<el-button :type="selectStatus" class="main-btn"
					:class="{ 'main-btn-warning': selectStatus == 'warning' }" @click="batchDel">批量删除</el-button>
			</div>
			<div class="right">
				<el-select class="department" v-model="query.departmentId" placeholder="请选择部门"
					@change="departmentChange" clearable>
					<el-option v-for="item in departmentOptions" :key="item.value" :label="item.label"
						:value="item.value" />
				</el-select>
				<el-input class="search-input" v-model="query.keyword" placeholder="请输入查询关键字" clearable>
					<template #append>
						<div class="search-btn" @click="searchBtn">查询</div>
					</template>
				</el-input>
			</div>
		</div>
		<!-- 表格 -->
		<el-table header-row-class-name="main-table-header" :data="tableData" border height="670"
			@selection-change="handleSelectionChange" @row-dblclick="dbEdit">
			<el-table-column type="selection" width="38" fixed />
			<el-table-column label="部门" min-width="120" fixed align="center" prop="department.name"></el-table-column>
			<el-table-column label="姓名" min-width="90" fixed align="center" prop="name">
        <template #default="scope">
          <p>{{scope.row.name}}</p>
          <p v-if="scope.row.realName && scope.row.realName != scope.row.name">({{scope.row.realName}})</p>
        </template>
      </el-table-column>
			<el-table-column label="性别" min-width="50" align="center" prop="gender"></el-table-column>
			<el-table-column label="出生年月" min-width="130" align="center" prop="birthday"></el-table-column>
			<el-table-column label="文化程度" min-width="100" align="center" prop="education"></el-table-column>
			<el-table-column label="入职时间" min-width="130" align="center" prop="workTime"></el-table-column>
			<el-table-column label="联系电话" min-width="120" align="center" prop="phone"></el-table-column>
			<el-table-column label="籍贯" min-width="130" align="center" prop="nativePlace"></el-table-column>
			<el-table-column label="身份证号" min-width="180" align="center" prop="idCard"></el-table-column>
			<el-table-column label="开户银行" min-width="120" align="center" prop="bank"></el-table-column>
			<el-table-column label="银行账号" min-width="180" align="center" prop="bankAccount"></el-table-column>
			<el-table-column label="在职状态" min-width="80" align="center" fixed="right" prop="status">
                <template #default="scope">
                    <el-tag v-if="scope.row.status == 1" type="success">在职</el-tag>
                    <el-tag v-else type="danger">离职</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="排序" min-width="50" align="center" fixed="right" prop="sort"></el-table-column>
			<el-table-column fixed="right" label="操作" width="230" align="center">
				<template #default="scope">
					<el-button type="primary" size="small" @click="detailsClick(scope.row)">查看详情</el-button>
          <el-button type="primary" size="small" @click="changeClick(scope.row)">变动管理</el-button>
					<!-- <el-button type="primary" size="small" @click="editClick(scope.row)" v-if="!scope.row.editStatus">编辑
					</el-button>
					<el-button type="primary" size="small" @click="saveClick(scope.row, scope.$index)"
						v-if="scope.row.editStatus">保存</el-button> -->
					<el-button type="danger" size="small" @click="deleteRow(scope.$index)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background layout="prev, pager, next, total, sizes, jumper" :total="query.total"
			v-model:currentPage="query.page" v-model:page-size="query.pagesize" @size-change="getList"
			@current-change="getList" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500]" />
		<!-- 详情弹窗 -->
		<el-dialog v-model="detailsDialogVisible" title="个人信息详情" width="1000px">
			<infoDetails :info="info" @onSave="saveClick"></infoDetails>
		</el-dialog>
		<!-- 导入弹窗 -->
		<el-dialog v-model="importDialogVisible" title="导入" width="800px">
			<el-form ref="importFormRef" :model="importForm" :rules="importRules" label-width="120px"
				class="demo-ruleForm" size="large" status-icon>
				<el-form-item label="模板下载:">
					<el-button type="primary" @click="downloadTemplate">点击模板下载</el-button>
				</el-form-item>
				<el-form-item label="部门选择:" prop="departmentId">
					<el-select class="department" v-model="importForm.departmentId" placeholder="请选择部门" clearable>
						<el-option v-for="item in departmentOptions" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
          部门为空时，人员导入时按模板中的部门进行导入
				</el-form-item>
				<el-form-item label="上传文件:" prop="file">
					<el-upload v-model:file-list="importForm.file" class="upload-demo" :limit="1" :auto-upload="false">
						<el-button type="primary">点击上传文件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="main-btn main-btn-primary"
						@click="importSubmitForm(importFormRef)">立即提交</el-button>
					<el-button class="main-btn" @click="importResetForm(importFormRef)">重置</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
    <!-- 变动管理弹窗 -->
    <el-dialog v-model="changeDialogVisible" title="信息变动管理" width="1000px">
      <infoChange :info="info" @onSave="saveClick" @onChange="getList"></infoChange>
    </el-dialog>
    <!-- 银行信息导入弹窗 -->
    <el-dialog v-model="importBankDialogVisible" title="导入银行信息" width="800px">
      <el-form ref="importBankFormRef" :model="importBankForm" :rules="importBankRules" label-width="120px"
        class="demo-ruleForm" size="large" status-icon>
        <el-form-item label="模板下载:">
          <el-button type="primary" @click="downloadBankTemplate">点击模板下载</el-button>
        </el-form-item>
        <el-form-item label="上传文件:" prop="file">
          <el-upload v-model:file-list="importBankForm.file" class="upload-demo" :limit="1" :auto-upload="false">
            <el-button type="primary">点击上传文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="main-btn main-btn-primary"
            @click="importBankSubmitForm(importBankFormRef)">立即提交</el-button>
          <el-button class="main-btn" @click="importBankResetForm(importBankFormRef)">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
	</div>
</template>
<script setup>
	import {
		reactive,
		ref
	} from "@vue/reactivity";
	import {
		ElMessage,
		ElMessageBox
	} from "element-plus";
	import {
		fetchList,
		save,
		batchUpdate
	} from "@/api/person";
	import {
		fetchList as fetchDepartmentList
	} from "@/api/department";
	import {
		onMounted
	} from "vue";
	import axios from "axios";
	import infoDetails from "./components/infoDetails.vue";
  import infoChange from "./components/infoChange.vue";

	onMounted(() => {
		getList();
		getDepartmentList();
	});
	// 详情
    const info = ref({})
	const detailsDialogVisible = ref(false);
	const detailsClick = (row) => {
        info.value = row
		detailsDialogVisible.value = true
	};
  const changeDialogVisible = ref(false);
  const changeClick = (row) => {
    info.value = row
    changeDialogVisible.value = true
  };
	// 添加
	const addData = () => {
        info.value = false
		detailsDialogVisible.value = true
		// tableData.value.unshift({
		// 	department: {
		// 		id: ""
		// 	},
		// 	status: 1,
		// 	editStatus: true,
		// });
	};
	//批量离职
	const batchQuit = () => {
		if (SelectList.value.length == 0) {
			ElMessage.error("请至少选中一条信息！");
		} else {
			ElMessageBox.confirm("确定要批量离职吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					batchUpdate({
						ids: SelectList.value.map((e) => e.id),
						field: "status",
						value: 2,
					}).then(() => {
						ElMessage.success("批量离职成功！");
						getList();
					});
				})
				.catch(() => {});
		}
	};
	//批量删除
	const selectStatus = ref("info");
	const batchDel = () => {
		if (SelectList.value.length == 0) {
			ElMessage.error("请至少选中一条信息！");
		} else {
			ElMessageBox.confirm("确定要删除所有选中信息吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
				.then(() => {
					batchUpdate({
						ids: SelectList.value.map((e) => e.id),
						field: "del",
						value: 1,
					}).then(() => {
						ElMessage.success("批量删除成功！");
						getList();
					});
				})
				.catch(() => {});
		}
	};
	// 选择部门
	const departmentOptions = ref([]);

	const getDepartmentList = () => {
		fetchDepartmentList().then((res) => {
			let list = res.data.list;
			departmentOptions.value = [];
			list.forEach((item) => {
				departmentOptions.value.push({
					value: item.id,
					label: item.name,
				});
			});
		});
	};

	const departmentChange = (val) => {
		console.log(val);
	};
	//搜索
	const query = ref({
		departmentId: "",
		keyword: "",
		page: 1,
		pagesize: 15,
		total: "",
		sort: "-sort,+id",
	});
	const searchBtn = () => {
		getList();
	};
	// 表格
	const tableData = ref([]);

	const getList = () => {
		fetchList(query.value).then((res) => {
			tableData.value = res.data.list;
			query.value.total = res.data.total;
		});
	};

	// 表格编辑
	const editClick = (row) => {
		row.editStatus = true;
	};
	// 表格双击编辑
	const dbEdit = (row) => {
		row.editStatus = true;
	};
	const saveClick = (row) => {
		if (!row.department || !row.department.id) {
			ElMessage.error("请选择部门！");
			return;
		}
		if (!row.name) {
			ElMessage.error("请输入姓名！");
			return;
		}
		ElMessageBox.confirm("确定要保存此行信息吗?", "Warning", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
			.then(() => {
				save(row).then((res) => {
          info.value = row
                    getList()
					ElMessage({
						type: "success",
						message: "保存成功！",
					});
				});
			})
			.catch(() => {
				// ElMessage({
				//   type: 'info',
				//   message: 'Delete canceled',
				// })
			});
	};
	const deleteRow = (index) => {
		ElMessageBox.confirm("确定要删除此行信息吗?", "Warning", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
			.then(() => {
				batchUpdate({
					ids: [tableData.value[index].id],
					field: "del",
					value: 1,
				}).then(() => {
					getList();
					ElMessage({
						type: "success",
						message: "删除成功！",
					});
				});
			})
			.catch(() => {});
	};
	// 多选
	const SelectList = ref([]);
	const handleSelectionChange = (val) => {
		SelectList.value = val;
		console.log(SelectList.value.length);
		if (val.length > 0) {
			selectStatus.value = "warning";
		} else {
			selectStatus.value = "info";
		}
	};
	// 性别
	const genderOptions = [{
			value: 1,
			label: "男",
		},
		{
			value: 2,
			label: "女",
		},
	];
	//文化程度
	const cultureOptions = [{
			value: 0,
			label: "初中",
		},
		{
			value: 1,
			label: "高中",
		},
		{
			value: 2,
			label: "中专",
		},
		{
			value: 3,
			label: "大专",
		},
		{
			value: 4,
			label: "本科",
		},
		{
			value: 5,
			label: "硕士",
		},
		{
			value: 6,
			label: "博士",
		},
		{
			value: 7,
			label: "博士后",
		},
	];
	// 政治面貌
	const faceOptions = [{
			value: 1,
			label: "团员",
		},
		{
			value: 2,
			label: "党员",
		},
		{
			value: 3,
			label: "群众",
		},
	];
	// 在职状态

	const onJobOptions = [{
			value: 1,
			label: "在职",
		},
		{
			value: 2,
			label: "离职",
		},
	];

	//导入
	const importDialogVisible = ref(false);
	const importFormRef = ref();
	const importForm = reactive({
		departmentId: "",
		status: 1,
		file: [],
	});

	const importRules = reactive({
		status: [{
			required: true,
			message: "请选择在职状态",
			trigger: "change",
		}, ],
		file: [{
			required: true,
			message: "请上传文件",
			trigger: "change",
		}, ],
	});
	const importPerson = () => {
		importForm.departmentId = "";
		importForm.status = 1;
		importForm.file = [];
		importDialogVisible.value = true;
	};
	const importSubmitForm = async (formEl) => {
		if (!formEl) return;
		await formEl.validate((valid, fields) => {
			if (valid) {
				//upload file through axois
				let formData = new FormData();
				formData.append("file", importForm.file[0].raw);
				formData.append("departmentId", importForm.departmentId);
				axios({
					method: "post",
					url: "/api/admin/person/import",
					data: formData,
					headers: {
						"Content-Type": "multipart/form-data",
						token: localStorage.getItem("token"),
					},
				}).then((res) => {
                    console.log(res)
                    if(res.data.code == 0) {
                        importDialogVisible.value = false;
                        ElMessage({
                            type: "success",
                            message: "导入成功！",
                        });
                        getList();
                    }else{
                        ElMessage({
                            type: "error",
                            message: res.data.desc,
                        });
                    }
				});
			} else {
				console.log("error submit!", fields);
			}
		});
	};

	const importResetForm = (formEl) => {
		if (!formEl) return;
		formEl.resetFields();
	};

	const downloadTemplate = () => {
		//vue3 download file
		const url =
			"https://yuweiyeke.oss-cn-zhangjiakou.aliyuncs.com/static/files/%E5%91%98%E5%B7%A5%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BFv2.xlsx";
		const link = document.createElement("a");
		link.style.display = "none";
		link.href = url;
		link.setAttribute("download", "员工导入模板.xlsx");
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const exportData = () => {
		let _query = Object.assign({}, query.value);
		_query.page = 1;
		_query.pagesize = 9999;
		fetchList(_query).then((res) => {
			let list = res.data.list;
			import("@/vendor/Export2Excel").then((excel) => {
				const tHeader = [
					"部门",
					"姓名",
					"性别",
					"出生年月",
					"文化程度",
					"政治面貌",
					"入职时间",
                    "工龄工资",
                    "岗位级别",
                    "岗位级别生效日期",
                    "社保级别",
                    "社保级别生效日期",
                    "绩效扣款等级系数",
                    "绩效扣款等级系数生效日期",
                    "餐补级别",
                    "餐补级别生效日期",
                    "有无车补",
                    "车补生效日期",
                    "是否住宿",
                    "住宿生效日期",
					"通迅地址",
					"联系电话",
					"籍贯",
					"身份证号",
					"社保入保时间",
                    "入保企业",
					"劳动合同起始日期",
                    "劳动合同终止日期",
					"商业保险起始日期",
                    "商业保险终止日期",
					"面试日期",
					"面试情况",
					"转正日期",
					"身份证归档日期",
					"毕业证归档日期",
					"劳动合同归档日期",
					"学习考试归档日期",
					"七日入职谈话归档日期",
					"三十日入职谈话归档日期",
                    "在职状态",
					"离职日期",
				];
				const filterVal = [
					"department",
					"name",
					"gender",
					"birthday",
					"education",
					"politics",
					"workTime",
                    "isWorkAge",
                    "jobLevel",
                    "jobLevelDate",
                    "insureLevel",
                    "insureLevelDate",
                    "performanceLevel",
                    "performanceLevelDate",
                    "mealLevel",
                    "mealLevelDate",
                    "carLevel",
                    "carLevelDate",
                    "accommodation",
                    "accommodationDate",
					"address",
					"phone",
					"nativePlace",
					"idCard",
					"socialSecurityTime",
                    "socialSecurityCompany",
                    "laborContractStartDate",
                    "laborContractEndDate",
                    "commercialInsuranceStartDate",
                    "commercialInsuranceEndDate",
					"interviewTime",
					"interviewResult",
					"regularTime",
					"idCardTime",
					"diplomaTime",
					"contractFileTime",
					"studyTime",
					"sevenDayTime",
					"thirtyDayTime",
                    "status",
					"leaveTime",
				];
				const data = formatJson(filterVal, list);
				excel.export_json_to_excel({
					header: tHeader,
					data,
					filename: "员工信息",
					autoWidth: false,
					bookType: "xlsx",
				});
			});
		});
	};

	const formatJson = (filterVal, jsonData) => {
		return jsonData.map((v) =>
			filterVal.map((j) => {
				if (j === "department" && v[j]) {
					return departmentOptions.value.find((e) => e.value == v[j].id).label;
				} else {
					return v[j];
				}
			})
		);
	};

	// 银行信息导入相关
	const importBankDialogVisible = ref(false);
	const importBankFormRef = ref();
	const importBankForm = reactive({
		file: [],
	});
	const importBankRules = reactive({
		file: [{
			required: true,
			message: "请上传文件",
			trigger: "change",
		}],
	});
	const importBank = () => {
		importBankForm.file = [];
		importBankDialogVisible.value = true;
	};
	const importBankSubmitForm = async (formEl) => {
		if (!formEl) return;
		await formEl.validate((valid, fields) => {
			if (valid) {
				let formData = new FormData();
				formData.append("file", importBankForm.file[0].raw);
				axios({
					method: "post",
					url: "/api/admin/person/importBank",
					data: formData,
					headers: {
						"Content-Type": "multipart/form-data",
						token: localStorage.getItem("token"),
					},
				}).then((res) => {
					if (res.data.code == 0) {
						importBankDialogVisible.value = false;
						ElMessage({
							type: "success",
							message: "导入成功！",
						});
						getList();
					} else {
						ElMessage({
							type: "error",
							message: res.data.desc,
						});
					}
				});
			} else {
				console.log("error submit!", fields);
			}
		});
	};
	const importBankResetForm = (formEl) => {
		if (!formEl) return;
		formEl.resetFields();
	};
	const downloadBankTemplate = () => {
		const url = "https://yuweiyeke.oss-cn-zhangjiakou.aliyuncs.com/static/files/%E9%93%B6%E8%A1%8C%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
		const link = document.createElement("a");
		link.style.display = "none";
		link.href = url;
		link.setAttribute("download", "银行信息导入模板.xlsx");
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};
</script>
<style lang="scss" scoped>
	::v-deep .el-table {
		.cell {
			padding: 0 5px;

			.el-input__wrapper {
				padding: 1px 5px;
			}
		}
	}
</style>
